<template>
    <i class="teacher-badge"></i>
</template>

<style lang="less" scoped>
.teacher-badge {
    display: inline-block;
    vertical-align: middle;
    width: .98rem;
    height: .4rem;
    background: url("../../assets/img/vteacher@3x.png") center/100% 100% no-repeat;
}
</style>

<script>
export default {
    name: 'k-badge-teacher',
    props: {
        level: Number
    }
}
</script>

